import { atom } from 'jotai';

import type { UserInfo } from '@/types/common';

export const userAtom = atom<UserInfo | null>(null);

// Returns a boolean value, true if the user has the "All" organization
export const userHasAllOrgAtom = atom((get) =>
  Object.keys(get(userAtom)?.permissions || []).includes('all')
);

// Returns a boolean value, true if the user is internal
export const userIsInternalAtom = atom((get) => !!get(userAtom)?.internal);

export default userAtom;
